import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import '../styles/platform.css';
import {
  getActiveNavId,
  getViewMeta,
  isFullBleedRoute,
} from '../config/nav';
import { computePipelineWarmth } from '../utils/contactMessages';
import { fetchCompanyForUser } from 'src/redux/actions/company.action';
import PlatformSidebar from './PlatformSidebar';
import PlatformTopbar from './PlatformTopbar';

function TouchesTopAction() {
  return (
    <button
      type="button"
      style={{
        border: 'none',
        borderRadius: 10,
        padding: '10px 16px',
        background: 'var(--primary-soft)',
        color: 'var(--primary)',
        fontFamily: 'var(--sans)',
        fontWeight: 600,
        fontSize: 14,
        cursor: 'pointer',
      }}
    >
      Approve all
    </button>
  );
}

function countPendingTouches(contacts = []) {
  let count = 0;

  contacts.forEach((contact) => {
    if (contact.frequency === 'None') {
      return;
    }

    if (Array.isArray(contact.messageQueue)) {
      contact.messageQueue.forEach((message) => {
        if (message?.status === 'Pending' || message?.messageStatus === 'Pending') {
          count += 1;
        }
      });
    }
  });

  return count;
}

function PlatformShell({ children, topbarActions: topbarActionsProp }) {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { allContacts = [] } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.login);

  useEffect(() => {
    if (user?.uid && (user.companyID || user.companyId)) {
      dispatch(fetchCompanyForUser(user));
    }
  }, [dispatch, user?.uid, user?.companyID, user?.companyId]);

  const activeId = getActiveNavId(pathname);
  const meta = getViewMeta(pathname);
  const fullBleed = isFullBleedRoute(pathname);

  const touchesBadge = useMemo(() => {
    const pending = countPendingTouches(allContacts);
    return pending > 0 ? pending : null;
  }, [allContacts]);

  const pipelineWarmth = useMemo(() => computePipelineWarmth(allContacts), [allContacts]);

  const topbarActions = activeId === 'touches' ? <TouchesTopAction /> : topbarActionsProp;

  return (
    <div className="nurturer-platform">
      <div className="platform-shell">
        <PlatformSidebar
          activeId={activeId}
          touchesBadge={touchesBadge}
          pipelineWarmth={pipelineWarmth}
        />
        <main className="platform-main">
          <PlatformTopbar title={meta.title} subtitle={meta.subtitle} actions={topbarActions} />
          <div className={`platform-content platform-scroll ${fullBleed ? 'full-bleed' : ''}`}>
            <div className="platform-legacy-view">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default PlatformShell;
